import React, { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Layout from "../Layout";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";

const SpinReport = () => {
  const { t } = useTranslation();
  const [getLogData, setLogData] = useState("");
  const [listing, setListing] = useState([]);
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 50,
  });
  const [pagination, setPagination] = useState({
    page: 0,
    totalPages: 0,
    hasPrevPage: false,
    hasNextPage: false,
  });

  const myLogData = async (page, type) => {
    const { status, data: response_users } = await apiGet(apiPath.spinReport, {
      ...search_params,
      page: page > 0 ? page : search_params?.page,
    });
    if (status === 200) {
      if (response_users.success == true) {
        setLogData(response_users?.results);
        const rows = response_users?.results?.data || [];
        setListing((prev) => (type === "add" ? [...prev, ...rows] : rows));
        setSearchParams((prev) => ({
          ...prev,
          page: response_users?.data?.page || prev.page,
        }));
        setPagination({
          page: response_users?.data?.page,
          totalPages: response_users?.data?.totalPages,
          hasPrevPage: response_users?.data?.hasPrevPage,
          hasNextPage: response_users?.data?.hasNextPage,
        });
      } else {
        setLogData({});
        setListing([]);
        setPagination({
          page: 1,
          totalPages: 0,
          hasPrevPage: false,
          hasNextPage: false,
        });
      }
    }
  };

  useEffect(() => {
    myLogData();
  }, []);

  const handleLoadMore = () => {
    myLogData((pagination?.page || search_params.page) + 1, "add");
  };

  return (
    <Layout>
      <div>
        <div className="history-overview-wrapper">
          <div className="desktop_card v-card v-sheet theme--light elevation-0">
            <div
              style={{ marginTop: "20px" }}
              className="history-card v-card v-sheet theme--light elevation-0"
            >
              {listing?.length > 0 ? (
                listing.map((item, key) => (
                  <div
                    key={item?._id || key}
                    className="row mx-1 mobile-reward-table"
                  >
                    <div className="mr-0 col col-6">
                      <div className="row reward-table-header pl-6 no-gutters">
                        <div className="col col-12">Spin Count</div>
                        <div className="col col-12">P/L</div>
                        <div className="col col-12">Settle Date</div>
                      </div>
                    </div>
                    <div className="col col-6">
                      <div className="row no-gutters">
                        <div className="col col-12">{item?.spin}</div>
                        <div className="col col-12">{item?.result}</div>
                        <div className="col col-12">
                          {moment(item?.createdAt).format(
                            "YYYY-MM-DD hh:mm:ss",
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col col-12">
                      <hr
                        role="separator"
                        aria-orientation="horizontal"
                        className="mx-2 v-divider theme--light"
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div className="row">
                  <div className="text-center pt-0 pb-8 col col-12">
                    <label className="referral-table-header subtitle-2">
                      You have no spins in this time period.
                    </label>
                  </div>
                </div>
              )}

              {pagination?.hasNextPage && (
                <div className="row no-gutters justify-center">
                  <div className="col col-6 pt-2 pb-4">
                    <button
                      type="button"
                      onClick={handleLoadMore}
                      className="history-tab-mobile v-btn v-btn--has-bg theme--light v-size--default primary"
                      style={{ width: "100%" }}
                    >
                      <span className="v-btn__content">
                        <span>{t("LoadMore")}</span>
                      </span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SpinReport;
